/// <amd-module name="typeahead/core/plugins/CompositePageLoadHandler" />
/// <amd-dependency path="typeahead/core/context" name="coreContext"/>
/// <amd-dependency path="uitk" name="uitk"/>

/// <reference path="../../../typings/typeahead/IPageLoadHandler.d.ts" />

import {ActivitiesSearchResultsPageHandler} from "typeahead/client/ActivitiesSearchResultsPageHandler";
import {CarSearchResultsPageHandler} from "typeahead/client/CarSearchResultsPageHandler";
import {ClientHandlerRegistry} from "typeahead/client/ClientHandlerRegistry";
import {FlightSearchResultsPageHandler} from "typeahead/client/FlightSearchResultsPageHandler";
import {HotelSearchResultsPageHandler} from "typeahead/client/HotelSearchResultsPageHandler";
import {MercuryWizardHandler} from "typeahead/client/MercuryWizardHandler";
import {OpenSearchPageHandler} from "typeahead/client/OpenSearchPageHandler";
import {UserAccountPageHandler} from "typeahead/client/UserAccountPageHandler";
import {DefaultPluginAssembly} from "typeahead/core/plugins/DefaultPluginAssembly";
import {abTest} from "typeahead/core/plugins/ExecutionHelper";
import {IPrefetchBucketAssignments, PrefetchLoader} from "typeahead/core/plugins/PrefetchLoader";
import {TypeaheadUtils} from "typeahead/core/TypeaheadUtils";

export const prefetchInstance = PrefetchLoader.getInstance();

export class CompositePageLoadHandler implements IPageLoadHandler {

    public static getInstance(): CompositePageLoadHandler {
        if (!CompositePageLoadHandler.instance) {
            CompositePageLoadHandler.instance = new CompositePageLoadHandler();
        }
        return CompositePageLoadHandler.instance;
    }

    private static instance: CompositePageLoadHandler;
    private static isPageLoadHandled: boolean = false;

    private constructor() {}

    public handlePageLoad(pluginAssembly: IPluginAssembly): void {
        if (!CompositePageLoadHandler.isPageLoadHandled) {
            let abIDs: string = abTest.getAllExperimentsAttribute(
                pluginAssembly.get(DefaultPluginAssembly.experimentIdentifier), "id").join("|");

            let options = {
                maxresults: 10,
            };

            let context: IContext = {
                clientId: TypeaheadUtils.getClientId(),
                deviceType: TypeaheadUtils.getDeviceType(),
                expuserid: TypeaheadUtils.getExpUserId(),
                getShortPackageType: (): string => { return undefined; },
                guid: TypeaheadUtils.getGuid(),
                lob: undefined, // lob is unknown during page load
                locale: coreContext.locale,
                serviceUrl: coreContext.serviceUrl,
                siteid: coreContext.siteid,
            };

            let pageLoadHandlers: IPageLoadHandler[] =
                pluginAssembly.get(DefaultPluginAssembly.pageLoadHandlerIdentifier);

            // Fetch the promise to get prefetch data and then perform all page load related actions
            prefetchInstance.prefetch(abIDs).done(() => {
                prefetchInstance.getPrefetchExperiments()
                    .done((experimentData: IPrefetchBucketAssignments) => {
                        abTest.evaluateAllExperiments(pluginAssembly, experimentData);
                    });
            });

            if (pageLoadHandlers && pageLoadHandlers.length > 0) {
                pageLoadHandlers.map((plugin: IPageLoadHandler) => {
                    plugin.handlePageLoad(options, context);
                });
            }

            this.registerClients();
            CompositePageLoadHandler.isPageLoadHandled = true;
        }
    }

    private registerClients() {
        ClientHandlerRegistry.registerClient(new ActivitiesSearchResultsPageHandler());
        ClientHandlerRegistry.registerClient(new CarSearchResultsPageHandler());
        ClientHandlerRegistry.registerClient(new FlightSearchResultsPageHandler());
        ClientHandlerRegistry.registerClient(new HotelSearchResultsPageHandler());
        ClientHandlerRegistry.registerClient(new MercuryWizardHandler());
        ClientHandlerRegistry.registerClient(new OpenSearchPageHandler());
        ClientHandlerRegistry.registerClient(new UserAccountPageHandler());

        ClientHandlerRegistry.handlePageLoad();
    }
}
